export const EMPTY_FUNCTION = () => {};
export const STOP_EVENT_FUNCTION = (e) => {
  e.stopPropagation();
  e.nativeEvent.stopImmediatePropagation();
};
